import { initializeApp } from 'firebase/app'
import { getMessaging, isSupported } from 'firebase/messaging'
import { getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database'

const firebaseConfig = {
  apiKey: 'AIzaSyAoPfOLbNd6S7HzfhLwADYNoeK1efus5a4',
  authDomain: 'neatly-1184.firebaseapp.com',
  databaseURL: 'https://neatly-1184.firebaseio.com',
  projectId: 'neatly-1184',
  storageBucket: 'neatly-1184.appspot.com',
  messagingSenderId: '520353546724',
  appId: '1:520353546724:web:c443945603739733fe47f1'
}
const firebaseApp = initializeApp(firebaseConfig)
let firebaseMessaging = null
let isSupportedMessaging = false
isSupported().then(result => {
  isSupportedMessaging = result
  if (result) {
    firebaseMessaging = getMessaging()
  }
  // console.log('check isSupportedMessaging', isSupportedMessaging)
}).catch(error => {
  console.log('check error', error)
})
const firebaseAuth = getAuth()
const firebaseDatabase = getDatabase()

export { firebaseApp, firebaseMessaging, firebaseAuth, firebaseDatabase, isSupportedMessaging }



// WEBPACK FOOTER //
// ./src/helpers/firebaseHelpers.js